// extracted by mini-css-extract-plugin
module.exports = {"request-details-modal__actions":"_1CN92YLxD6nc_F3Lu5m_DH"};